import React from 'react';
import { Link } from 'react-router-dom';

const OFFERINGS = [
  { icon: '🌐', title: 'Website Design & Development', desc: 'Custom, responsive websites built for performance and user experience.' },
  { icon: '🛒', title: 'E-Commerce Solutions', desc: 'Full-featured online stores with secure payment integration.' },
  { icon: '📦', title: 'CMS Development', desc: 'Content management systems that make updating your site easy.' },
  { icon: '☁️', title: 'Web Hosting', desc: 'Reliable, secure hosting solutions with 99.9% uptime guarantee.' },
  { icon: '🔧', title: 'Website Maintenance', desc: 'Ongoing support, updates, and performance optimization.' },
  { icon: '🔒', title: 'Web Security', desc: 'SSL certificates, security audits, and vulnerability protection.' },
];

const WebServices = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Web Services</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>End-to-end web solutions for your digital presence</p>
      </div>
    </section>

    <section className="py-5 bg-white">
      <div className="container py-3 text-center" style={{ maxWidth: 700 }}>
        <span className="badge px-3 py-2 mb-3" style={{ background: '#dbeafe', color: '#1a56db', fontSize: 13, fontWeight: 600, borderRadius: 40 }}>WEB SERVICES</span>
        <h2 className="fw-bold mb-3">What We Offer</h2>
        <p className="text-muted" style={{ fontSize: 17 }}>
          From design to deployment, we deliver complete web solutions tailored to your business goals.
        </p>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row g-4">
          {OFFERINGS.map((s, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-4">
              <div
                className="card h-100 border p-3"
                style={{ borderColor: '#e2e8f0', borderRadius: 14, transition: 'all 0.25s ease', cursor: 'pointer' }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 30px rgba(26,86,219,0.12)';
                  e.currentTarget.style.borderColor = '#bfdbfe';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.borderColor = '#e2e8f0';
                }}
              >
                <div className="card-body">
                  <div style={{ fontSize: 40 }} className="mb-3">{s.icon}</div>
                  <h5 className="fw-bold mb-2" style={{ color: '#1e293b' }}>{s.title}</h5>
                  <p className="text-muted small" style={{ lineHeight: 1.6 }}>{s.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #1a56db, #0ea5e9)' }}>
      <div className="container py-4">
        <h2 className="fw-bold mb-3">Ready to Build Your Web Presence?</h2>
        <p className="lead mb-4">Let's create something amazing together.</p>
        <Link to="/contact" className="btn btn-warning btn-lg fw-bold px-5">Contact Us →</Link>
      </div>
    </section>
  </>
);

export default WebServices;
